import { mediaData } from '@/mocks/homeData';

const mediaImages = [
  'https://readdy.ai/api/search-image?query=Intense%20crime%20drama%20confrontation%20scene%20with%20dramatic%20lighting%2C%20two%20powerful%20figures%20facing%20each%20other%20in%20a%20dark%20room%2C%20cinematic%20composition%20with%20deep%20shadows%2C%20warm%20and%20cool%20light%20contrast%2C%20film%20still%20aesthetic%2C%20high%20production%20value&width=640&height=360&seq=media-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20historical%20Chinese%20drama%20film%20set%20with%20traditional%20costumes%20and%20props%2C%20warm%20set%20lighting%2C%20production%20crew%20at%20work%2C%20authentic%20atmosphere%2C%20documentary%20style%2C%20rich%20texture&width=640&height=360&seq=media-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Summer%20movie%20themed%20collage%20with%20vibrant%20film%20strips%20and%20cinematic%20elements%2C%20bright%20warm%20colors%2C%20dynamic%20composition%2C%20entertainment%20and%20excitement%20vibe%2C%20promotional%20graphic%20design%20style%2C%20clean%20modern%20look&width=640&height=360&seq=media-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Intimate%20interview%20setting%20with%20a%20film%20director%20speaking%20in%20a%20cozy%20studio%20with%20warm%20ambient%20lighting%2C%20bookshelves%20and%20film%20posters%20in%20background%2C%20professional%20documentary%20style%2C%20thoughtful%20mood&width=640&height=360&seq=media-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Futuristic%20visual%20effects%20studio%20with%20large%20monitors%20displaying%20sci-fi%20scenes%2C%20artists%20working%20on%20CGI%20compositions%2C%20cool%20blue%20monitor%20glow%20contrasting%20with%20warm%20ambient%20lighting%2C%20creative%20tech%20atmosphere&width=640&height=360&seq=media-05&orientation=landscape',
];

const mediaItems = mediaData.map((item, i) => ({ ...item, img: mediaImages[i] }));

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精彩片段
          </h2>
          <p className="text-sm text-foreground-500 mt-1">花絮 · 访谈 · 预告</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item, index) => (
            <article
              key={index}
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={`天狼影院 - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-background-950/75 text-background-50 rounded whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-xs md:text-sm font-semibold text-foreground-950 mb-1 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-[11px] md:text-xs text-foreground-500 leading-snug line-clamp-2">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}